import React from 'react';
import { Container, Typography, Box, Card, CardContent } from '@mui/material';
import { LocalHospital } from '@mui/icons-material';

const MyCarePage: React.FC = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box display="flex" alignItems="center" mb={4}>
        <LocalHospital sx={{ mr: 2, fontSize: 32, color: 'primary.main' }} />
        <Typography variant="h4" component="h1">
          My Care
        </Typography>
      </Box>

      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Your Care Management
          </Typography>
          <Typography variant="body1" color="text.secondary">
            This page will show your current care plan, upcoming appointments, and care team information.
          </Typography>
          
          <Box mt={3}>
            <Typography variant="subtitle1" gutterBottom>
              Coming Soon:
            </Typography>
            <ul>
              <li>Current care plan and goals</li>
              <li>Upcoming appointments and reminders</li>
              <li>Your care team members</li>
              <li>Health progress tracking</li>
              <li>Medication management</li>
            </ul>
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
};

export default MyCarePage;
